import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '../../../../../../../../components/Common/UI/Dialog';
import Icons from '../../../../../../../../components/Common/Icons/Icons';
import Separator from '../../../../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../../../../components/Common/UI/Button';
import MediaModalContent from './Content';
import { useMessageManagerProvider } from '../../../../../../../context/messageManager';

interface IModalModuleMedia {
  triggerStyle?: string;
  trigger: React.ReactNode;
}

function ModalModuleMedia({ trigger, triggerStyle }: IModalModuleMedia) {
  const { selectedImage, selectedModule, handleSelectedModule, state, handleSelectedImage, activeTab, handleDispatch } =
    useMessageManagerProvider();

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { endOfStatement } = state.step2;

  const handleAdd = () => {
    if (selectedModule?.item && selectedImage && activeTab === 0) {
      handleSelectedModule({
        ...selectedModule,
        item: {
          ...selectedModule.item,
          imageUrl: selectedImage.imageUrl,
          qrCode: selectedImage.qrCode,
        },
      });
    }

    if (endOfStatement.selected && selectedImage && activeTab === 1) {
      handleDispatch({
        step2: {
          ...state.step2,
          endOfStatement: {
            ...endOfStatement,
            selected: {
              ...endOfStatement.selected,
              imageUrl: selectedImage.imageUrl,
              qrCode: selectedImage.qrCode,
            },
          },
        },
      });
    }

    handleSelectedImage(undefined);
  };

  return (
    <Dialog open={modalOpen} onOpenChange={isOpen => setModalOpen(isOpen)}>
      <DialogTrigger variant="ghost" className={triggerStyle}>
        {trigger}
      </DialogTrigger>
      <DialogContent className="max-w-[1170px] bg-[#F8F9FD]">
        <DialogTitle className="flex items-center gap-4 mb-[10px]">
          <Icons.Library className="size-[34px] [&_path]:fill-primary" />
          <div className="text-xl leading-none">Media Gallery</div>
        </DialogTitle>
        <MediaModalContent />
        <Separator className="!mt-0" />
        <div className="flex justify-end gap-4">
          <Button variant="link" className="py-3 hover:no-underline" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button
            className="py-3"
            onClick={() => {
              handleAdd();
              setModalOpen(false);
            }}
          >
            Apply
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

ModalModuleMedia.defaultProps = {
  triggerStyle: '',
};

export default ModalModuleMedia;
